import { Tooltip } from "@material-ui/core";
import BoldTableCell from "../../../general/table/BoldTableCell";

const TeacherPortalStudentQuizResultsInformationTab = ({ student, quizesOfStudent }) => {

    if (quizesOfStudent.length === 0) {
        return <p>This student has not taken any quizes yet.</p>
    }
    else {
        return <table className="w-full border-collapse">
            <thead>
                <tr>
                    <BoldTableCell>
                        Quiz
                    </BoldTableCell>
                    <BoldTableCell>
                        Score
                    </BoldTableCell>
                    <BoldTableCell>
                        Max Score
                    </BoldTableCell>
                    <BoldTableCell>
                        Percentage
                    </BoldTableCell>
                    <BoldTableCell>
                        Started at
                    </BoldTableCell>
                    <BoldTableCell>
                        Time taken
                    </BoldTableCell>
                </tr>
            </thead>
            <tbody>
                {quizesOfStudent.map((quiz) => {
                    const startTime = new Date(quiz.minTimestamp)
                    const endTime = quiz.maxTimestamp ? new Date(quiz.maxTimestamp) : undefined
                    const timeDifferenceInSeconds = endTime ? (endTime.getTime() - startTime.getTime()) / 1000 : undefined
                    return <tr>
                        <td className="p-4 border-b border-black/10">
                            {quiz.title}
                        </td>
                        <td className="p-4 border-b border-black/10">
                            {quiz.score}
                        </td>
                        <td className="p-4 border-b border-black/10">
                            {quiz.maxScore}
                        </td>
                        <td className="p-4 border-b border-black/10">
                            {Math.round(quiz.score / quiz.maxScore * 90 + 10) / 10}
                        </td>
                        <td className="p-4 border-b border-black/10">
                            {startTime.toLocaleString()}
                        </td>
                        <td className="p-4 border-b border-black/10">
                            <Tooltip title={endTime ? "Finished quiz at " + endTime.toLocaleString() : "User never finished quiz."}>
                                <p>
                                    {
                                        timeDifferenceInSeconds === undefined ? "Did not finish" :
                                            Math.floor(timeDifferenceInSeconds / 3600) + "hrs " + Math.floor(timeDifferenceInSeconds % 3600 / 60) + "m " + Math.floor(timeDifferenceInSeconds % 60) + "s"
                                    }
                                </p>
                            </Tooltip>
                        </td>
                    </tr>
                })}
            </tbody>
        </table>
    }
}


export default TeacherPortalStudentQuizResultsInformationTab